<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$world"
				start
			/>
			<translate>Domain</translate>
		</v-card-title>
		<v-card-text class="pb-0">
			<v-row>
				<v-col>
					<span>
						<translate>
							The current Domain is
						</translate>
						: {{ currentDomain }}
					</span>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-select
						v-model="domain"
						:items="domains"
						item-title="name"
						item-value="id"
						:label="$gettext('Domain')"
						variant="outlined"
					/>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn
				color="primary"
				type="submit"
				@click="updateDomain"
			>
				<translate>Change Domain</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import axios from 'axios';
import displayError from 'laravel-front-library/src/utils/displayError/displayError';

export default {
	props: {
		currentDomain: {
			type: String,
			required: true,
		},
		postUrl: {
			type: String,
			required: true,
		}
	},

	data () {
		return {
			domains: [],
			currentId: null,
			domain: null,
		};
	},

	mounted () {
		const uri = window.location.search.substring(1);
		const params = new URLSearchParams(uri);

		this.getDomainData();
		if (params.get('id')) {
			this.currentId = params.get('id');
		}
	},

	methods: {
		/**
		 * Fetches the available domains
		 *
		 * @returns {void}
		 */
		getDomainData () {
			axios.get('/bo/domains').then((resp) => {
				this.domains = resp.data;
				this.domain = this.domains.find((domain) => {
					return domain.name === this.currentDomain;
				}).id;
			});
		},

		/**
		 * Send the new domain to the backend
		 *
		 * @returns {void}
		 */
		updateDomain () {
			const formData = new FormData();

			formData.append('domain', this.domain);
			formData.append('id', this.currentId);

			axios({
				url: this.postUrl,
				method: 'POST',
				dataType: 'application/json',
				data: formData,
				config: {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
				},
			}) .then(() => {
				window.location.reload();
			}).catch((error) => {
				displayError(error);
				window.location.reload();
			});
		}
	}
};
</script>
